import styled from 'styled-components';
import Dropdown from 'library/components/form-components/dropdown';
import { GroupsNew, Pencil, ExitGroup } from 'library/icons';
import { BaseStyleguideColors } from 'context/color';

const baseSVGColor = BaseStyleguideColors.yellow500;

const ProfFiltersDropdown = styled(Dropdown)`
  display: flex;
  width: 350px;
  max-width: 350px;
  > div {
    display: flex;
  }
  &:focus,
  :hover {
    border: 1px solid ${(props) => props.theme.colors.yellow400}!important;
  }
  .prof_center_group_filters {
    border: 1px solid ${(props) => props.theme.colors.yellow400}!important;
  }
`;

const UsersIcon = styled(GroupsNew)`
  width: 1em;
  height: 1em;
  font-size: 1.5em;
  color: ${baseSVGColor};
`;

const AllUsersIcon = styled(ExitGroup)`
  color: ${baseSVGColor};
  margin-right: 1em;
`;

const PencilIcon = styled(Pencil)`
  color: ${baseSVGColor};
  margin-right: 1em;
`;

const GroupOption = styled.div`
  height: 49px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 1em;
  color: #2e2e2e;
  background-color: ${(props) =>
    props.active ? 'rgba(0, 0, 0, 0.08)' : 'initial'};
  &:focus,
  :hover {
    background: ${(props) => props.theme.colors.yellow050}!important;
  }
`;

export {
  ProfFiltersDropdown,
  UsersIcon,
  AllUsersIcon,
  PencilIcon,
  GroupOption,
};
